/**
 * Utility functions to manually fix focus mode issues
 */

/**
 * Completely disable focus mode and clean up all related elements
 */
export const forceDisableFocusMode = () => {
  console.log('Force disabling focus mode...');
  
  // 1. Disable focus mode in TourContext if available
  const tourContext = window.tourContext;
  if (tourContext && typeof tourContext.setFocusMode === 'function') {
    tourContext.setFocusMode(false);
    console.log('Disabled focus mode via TourContext');
  }
  
  // 2. Remove focus-mode class from body
  document.body.classList.remove('focus-mode');
  console.log('Removed focus-mode class from body');
  
  // 3. Remove focus mode styles
  const focusStyles = document.getElementById('tour-focus-mode-styles');
  if (focusStyles) {
    focusStyles.remove();
    console.log('Removed focus mode styles');
  }
  
  // 4. Remove overlay elements
  const overlays = document.querySelectorAll('.focus-overlay');
  overlays.forEach(overlay => {
    overlay.style.display = 'none';
    overlay.remove();
  });
  console.log('Removed overlay elements');
  
  // 5. Reset pointer events on all elements
  const allElements = document.querySelectorAll('*');
  allElements.forEach(element => {
    element.style.pointerEvents = '';
  });
  console.log('Reset pointer events on all elements');
  
  // 6. Try to call any global reset functions
  if (window.resetFocusMode && typeof window.resetFocusMode === 'function') {
    window.resetFocusMode();
    console.log('Called global resetFocusMode function');
  }
  
  if (window.resetDataImportFocusMode && typeof window.resetDataImportFocusMode === 'function') {
    window.resetDataImportFocusMode();
    console.log('Called global resetDataImportFocusMode function');
  }
  
  console.log('Focus mode force disable complete');
};

/**
 * Check if focus mode is currently enabled
 */
export const isFocusModeEnabled = () => {
  const hasFocusClass = document.body.classList.contains('focus-mode');
  const hasOverlay = document.querySelector('.focus-overlay');
  const hasStyles = document.getElementById('tour-focus-mode-styles');
  
  return {
    hasFocusClass,
    hasOverlay: !!hasOverlay,
    hasStyles: !!hasStyles,
    isFullyEnabled: hasFocusClass || hasOverlay || hasStyles
  };
};

/**
 * Debug focus mode issues
 */
export const debugFocusMode = () => {
  const status = isFocusModeEnabled();
  console.log('Focus mode debug info:', status);
  
  if (status.hasFocusClass) {
    console.log('Focus class found on body');
  }
  
  if (status.hasOverlay) {
    console.log('Focus overlay element found');
  }
  
  if (status.hasStyles) {
    console.log('Focus mode styles found');
  }
  
  return status;
};

// Expose functions globally for easy access in browser console
window.forceDisableFocusMode = forceDisableFocusMode;
window.isFocusModeEnabled = isFocusModeEnabled;
window.debugFocusMode = debugFocusMode;

console.log('Manual focus fix utilities loaded. Available functions:');
console.log('- window.forceDisableFocusMode()');
console.log('- window.isFocusModeEnabled()');
console.log('- window.debugFocusMode()');